import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SessionTimeoutModal from "@/components/SessionTimeoutModal";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import LLCDetail from "@/pages/LLCDetail";
import Investors from "@/pages/Investors";
import Vendors from "@/pages/Vendors";
import Checkbook from "@/pages/Checkbook";
import Categories from "@/pages/Categories";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Setup from "@/pages/Setup";
import Tasks from "@/pages/Tasks";
import Layout from "@/components/Layout";
import { usePageview } from "@/hooks/usePageview";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-600">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PageviewTracker = () => {
  usePageview();
  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageviewTracker />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="llc/:llcId" element={<LLCDetail />} />
            <Route path="investors" element={<Investors />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="checkbook" element={<Checkbook />} />
            <Route path="checkbook/:llcId" element={<Checkbook />} />
            <Route path="categories" element={<Categories />} />
            <Route path="reports" element={<Reports />} />
            <Route path="users" element={<Users />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="setup" element={<Setup />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
        <SessionTimeoutModal />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
